import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {HomePage} from './home.page';
import {SharedModuleModule} from '../../shared-module/shared-module.module';
import {AddToHomeComponent} from '../../components/add-to-home/add-to-home.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		RouterModule.forChild([
			{
				path: '',
				component: HomePage
			}
		]),
		SharedModuleModule
	],
	declarations: [HomePage, AddToHomeComponent]
})
export class HomePageModule {}
